// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../var/task/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".doc-box[data-v-fea8c832]{display:inline-block}a[data-v-fea8c832]{color:#337ab7}", ""]);
// Exports
module.exports = exports;
